import { useEffect, useState } from "react";

import { newrelic } from "@jti/fe-clients";
import { SubscriptionsApi } from "@jti/rest-api";
import { formatDate } from "@jti/ui";

const useSubscriptionBillingDate = () => {
  const [billingDate, setBillingDate] = useState("");

  useEffect(() => {
    const api = SubscriptionsApi.init();
    api
      .getSubscriptionConfigurations()
      .then((response) => {
        setBillingDate(response.nextChargeAt);
      })
      .catch((error) => {
        const errorMessage = "Error fetching subscription billing date: ";
        console.error(errorMessage, error);
        newrelic.noticeError(new Error(errorMessage, { cause: error }));
      });
  }, []);

  return billingDate ? formatDate(billingDate) : "";
};

export default useSubscriptionBillingDate;
